var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectorUp = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 7,
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 6L6 1L11 6",
  stroke: "#656D7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectorUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "63948983c8a7e3417aef5ca9fe5e116a.svg";